import Modal from "@components/Modal/Modal";
import NewLayout from "@components/new-ui/Layout";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import React, { FC } from "react";
import FAQAccordion from "./Accordion/FAQAccordion";
import CtaButton from "./CtaButton";
import SeoFaq from "./SeoFaq";
import AppButton from "./Typography/AppButton";
import BookDemoButton from "./Webinar/BookDemoButton";

interface IntegrationTemplateProps {
    integrationData: any;
}

const IntegrationTemplate: FC<IntegrationTemplateProps> = ({ integrationData }) => {
    const [modalHeader, setModalHeader] = React.useState<string | null>(null);
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [loaded, setLoaded] = React.useState(false);

    const handleClose = () => {
        setModalHeader(null);
        setShowModal(false);
    };

    const { landing_block_data, base_dir, logo, small_icon, client_logos, content_block, meta_title, meta_description, cta_block, slug, faq_title, faq } = integrationData;

    const hasCtaBlock = Object.keys(cta_block).length > 0;

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });
    let faqData: any;

    switch (slug) {
        case "woocommerce":
            faqData = {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: [
                    {
                        "@type": "Question",
                        name: "What is WhatsApp WooCommerce integration?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "WhatsApp WooCommerce integration is a simple and easy to use tool for your store. This integration will help you automate orders, replies to customers and reach them on their preferred space WhatsApp.",
                        },
                    },
                    {
                        "@type": "Question",
                        name: "What are the Advantages of Integrating WhatsApp with WooCommerce?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "<ol><li>Increase sales and improve customer service.</li> <li>Boost engagement with your brand by offering more personalized services to your customers.</li><li> Gain more exposure on social media channels and increase visibility of your brand </li></ol>",
                        },
                    },
                    {
                        "@type": "Question",
                        name: "What are the benefits of having a WhatsApp Shopify integration",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "<span>Connecting your WhatsApp and Shopify accounts will allow you to:</span><ul><li>Send product updates and messages to your customers on WhatsApp.</li> <li>Sync up customer information from WhatsApp with the data in your Shopify store.</li></ul>",
                        },
                    },
                    {
                        "@type": "Question",
                        name: "What kind of messages can be sent with the WhatsApp Shopify integration?",
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: "<span>You can use them to send out product updates or promotions, announce new products and services, share images of your products, or even provide customer service. Read our blog on <a href='/blog/whatsapp-for-shopify' >how to integrate your Shopify store with WhatsApp</a> to get started</span>",
                        },
                    },
                ],
            };
            break;
        default:
        // code block
    }
    const giveFaq = (slug: any) => {
        const faqs = {
            // woocommerce: [
            //     {
            //         title: " What is WhatsApp WooCommerce integration?",
            //         description:
            //             "WhatsApp WooCommerce integration is a simple and easy to use tool for your store. This integration will help you automate orders, replies to customers and reach them on their preferred space WhatsApp.",
            //     },
            //     {
            //         title: " What are the Advantages of Integrating WhatsApp with WooCommerce?",
            //         description: (
            //             <ol>
            //                 <li>Increase sales and improve customer service.</li>
            //                 <li>Boost engagement with your brand by offering more personalized services to your customers.</li>
            //                 <li> Gain more exposure on social media channels and increase visibility of your brand </li>
            //             </ol>
            //         ),
            //     },
            // ],
            shopify: [
                {
                    title: " What are the benefits of having a WhatsApp Shopify integration?",
                    description: (
                        <>
                            <span>Connecting your WhatsApp and Shopify accounts will allow you to:</span>
                            <ul>
                                <li>Send product updates and messages to your customers on WhatsApp.</li>
                                <li>Sync up customer information from WhatsApp with the data in your Shopify store </li>
                            </ul>
                        </>
                    ),
                },
                {
                    title: " What kind of messages can be sent with the WhatsApp Shopify integration?",
                    description: (
                        <span>
                            You can use them to send out product updates or promotions, announce new products and services, share images of your products, or even provide customer
                            service. Read our blog on{" "}
                            <a href="/blog/whatsapp-for-shopify" style={{ textDecoration: "none" }}>
                                how to integrate your Shopify store with WhatsApp
                            </a>{" "}
                            to get started
                        </span>
                    ),
                },
            ],
        };
        if (slug === "zoho") {
            return faq;
        }
        // else if (slug === "woocommerce") {
        //     return faqs.woocommerce;
        // }
        else {
            return faqs.shopify;
        }
    };

    const carouselSlides = ["customer-1.png", "customer-2.png", "customer-3.png", "customer-4.png"];
    return (
        <NewLayout title={meta_title} description={meta_description} canonical={`https://gallabox.com/whatsapp-integrations/${slug}`}>
            <SeoFaq faq={faqData} />
            <section className="relative md:pt-10 integrations-cms">
                <section
                    className="landing"
                    // style={{
                    //     backgroundImage: `url('/integrations/${base_dir}/${landing_block_data.backgroundBanner}')`,
                    // }}
                >
                    {/* Landing Block */}
                    <div className="container mx-auto">
                        <div className="flex">
                            <div>
                                <img src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${logo}`} className="mt-5 mx-auto md:mx-0" alt={`${base_dir} logo`} />
                                <h1 className="landing-title mt-5 text-center md:text-left font-bold" style={{ fontSize: "40px", lineHeight: "50px", letterSpacing: "0.02em" }}>
                                    {landing_block_data.header}
                                </h1>

                                <ul className="landing-list">
                                    {landing_block_data.bulletedList.map((item: any) => (
                                        <h2 className="m-0 p-0 font-normal capitalize" style={{ fontSize: "18px" }} key={item}>
                                            <li className="capitalize text-left">{item}</li>
                                        </h2>
                                    ))}
                                </ul>
                                <div className="pt-4 lg:pt-0 flex-row gap-4 justify-center md:justify-start mx-auto md:mx-0 lg:mb-20 lg:py-9 ">
                                    <div className="lg:pt-6 text-center md:flex lg:gap-6     grid grid-cols-2">
                                        <a
                                            href="https://app.gallabox.com/signup"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="px-6 border py-3 border-solid border-blue-500  text-blue-500 bg-white rounded-md hover:no-underline focus:outline-none hover:shadow-2xl text-base font-medium flex items-center "
                                        >
                                            Sign Up
                                        </a>
                                        <BookDemoButton className="py-4" />
                                    </div>
                                </div>
                            </div>
                            <img
                                src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${landing_block_data.rightImage}`}
                                className="ml-auto mt-auto object-contain landing-right-banner"
                                alt={`${landing_block_data.header}${landing_block_data.coloredText}`}
                            />
                        </div>
                    </div>
                </section>
                {/* Integrations CTA block */}
                {hasCtaBlock && (
                    <section className="integrations-cta">
                        <div
                            className="container py-7 mx-auto card "
                            style={{
                                background: cta_block.backgroundColor,
                            }}
                        >
                            <div className="flex justify-between">
                                <h2 className="card-title my-0 flex items-center">
                                    {cta_block.text}
                                    <img src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${small_icon}`} alt={`${base_dir} logo`} className="ml-3" />
                                </h2>
                                <AppButton
                                    href="https://app.gallabox.com/signup"
                                    buttonText={"Get Started"} // className="transition   duration-600 text-base ease-in-out cursor-pointer rounded-full  py-3 lg:px-10 lg:py-1 bg-crayola-blue text-white hover:no-underline hover:shadow-lg "
                                ></AppButton>
                            </div>
                        </div>
                    </section>
                )}

                <section className={`integrations-clients ${!hasCtaBlock && "my-20"}`}>
                    <div className="container mx-auto">
                        <h2 className="my-0 title capitalize">
                            Trusted By Many <span className=" capitalize ">{slug}</span> Stores And <b>10,000+</b> Businesses
                        </h2>
                        <div className="images-block">
                            {client_logos.map((logo: string, index: number) => (
                                <img key={index} src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${logo}`} alt="client-logo" />
                            ))}
                        </div>
                    </div>
                </section>
                <section className="features-block">
                    <div className="container mx-auto">
                        <div className="flex justify-between items-center">
                            <div>
                                <h2 className="my-0 title capitalize">{content_block.title}</h2>
                                <div className="flex mt-10 client-logos">
                                    <img src="https://assets.gallabox.com/gb-home/integrations/gallabox-logo.svg" alt="gallabox-logo" />
                                    <img src="https://assets.gallabox.com/gb-home/integrations/cross-icon.svg" alt="cross mark" />
                                    <img src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${logo}`} alt={`${base_dir} logo`} />
                                </div>
                                <img
                                    style={content_block?.additionalImagesStyles}
                                    src={`https://assets.gallabox.com/gb-home/integrations/${base_dir}/${content_block.person_image}`}
                                    className="mx-auto mt-10 person-image"
                                    alt="happy person image"
                                />
                            </div>
                            <div className="flex display-cards">
                                <div className="card relative mr-10">
                                    <img src="https://assets.gallabox.com/gb-home/integrations/whatsapp-logo.png" className="m-auto" alt="whatsapp-logo" />
                                    <h3 className="card-text capitalize text-3xl">{content_block.card_content_1}</h3>
                                    <div className="pink-circle"></div>
                                </div>
                                <div className="card relative">
                                    <img src="https://assets.gallabox.com/gb-home/integrations/bell-notification.svg" className="m-auto" alt="bell-notification" />
                                    <h3 className="card-text capitalize">{content_block.card_content_2}</h3>
                                    <div className="sky-blue-circle"></div>
                                    <div className="dark-blue-circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="table-view">
                    <div className="container mx-auto">
                        <div className="flex">
                            <div className="md:mr-20 mb-3 md:mb-auto">
                                <h2 className=" my-0 mb heading capitalize">Bulk Broadcast Marketing Campaigns</h2>
                                <img src="https://assets.gallabox.com/gb-home/target_customer.png" alt="Bulk Broadcast Marketing Campaigns" />
                                <div className="flex justify-center md:mt-10">
                                    <CtaButton text="Broadcast Now" type="outline" />
                                </div>
                            </div>
                            <div>
                                <h2 className="my-0 heading capitalize">Collaborate Via Shared Team Inbox</h2>
                                <img src="https://assets.gallabox.com/gb-home/messagingDemo.png" alt="Collaborate Via Shared Team Inbox" />
                                <div className="flex justify-center md:mt-10">
                                    <CtaButton text="Get Automated" type="outline" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="flex items-center justify-center max-w-963  object-contain">
                    <img src="https://assets.gallabox.com/gb-home/integrations.png" alt="integrations" />
                </div>

                <section className="client-love">
                    <div className="container mx-auto">
                        <p className="sub-title">CLIENT LOVE</p>
                        <p className="title">Our Customers</p>
                    </div>
                    <div className="images">
                        <div ref={sliderRef} className="keen-slider">
                            {carouselSlides.map((carousel, idx) => (
                                <div key={`carousal_${idx}`} className="keen-slider__slide">
                                    <img src={`https://assets.gallabox.com/gb-home/${carousel}`} alt="customer testimony image" className="mx-auto" />
                                </div>
                            ))}
                        </div>
                        <div className="mt-10">
                            {loaded && instanceRef.current && (
                                <div className="dots">
                                    {[...Array(instanceRef.current.track.details.slides.length).keys()].map((idx) => {
                                        return (
                                            <button
                                                key={idx}
                                                onClick={() => {
                                                    instanceRef.current?.moveToIdx(idx);
                                                }}
                                                className={"dot" + (currentSlide === idx ? " active" : "")}
                                            ></button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                {/* FAQ */}
                <section className="bg-rhino">
                    <div className="max-w-6xl mx-auto py-20 p-4 flex flex-col items-center">
                        <h2 className="p-0 m-0 text-2xl lg:text-3xl font-medium text-center max-w-screen-md leading-snug tracking-wide mb-14 text-white capitalize">
                            {faq_title}: FAQs
                        </h2>
                        <div className="max-w-screen-md w-full mx-auto flex flex-col gap-6 text-white">
                            <FAQAccordion title="FAQ" items={giveFaq(slug)} />
                        </div>
                    </div>
                </section>
                {/* mobile app */}
                <section className="bg-rhino">
                    <div className="max-w-6xl mx-auto px-4 pt-24 md:pb-24 flex flex-col lg:flex-row gap-12 mb-6 lg:mb-24 w-full">
                        <div style={{ flex: 0.45 }} className="hidden md:flex justify-end relative">
                            <img className="lg:absolute -top-4 mx-auto lg:mr-auto w-60" alt="Gallabox mobile app" src="https://assets.gallabox.com/gb-home/homepage-mobile.svg" />
                        </div>
                        <div style={{ flex: 0.55 }} className="flex flex-col items-center lg:items-start">
                            <p className="text-center lg:text-left p-0 m-0 tracking-wider text-base uppercase font-bold mb-2 text-caribbean-green">Mobile app</p>
                            <p className="text-center lg:text-left p-0 m-0 text-3xl font-bold max-w-screen-md leading-snug tracking-wide text-white mb-3">
                                Get the most of your customer interactions
                            </p>
                            <p className="text-center lg:text-left m-0 p-0 text-base leading-relaxed max-w-lg text-white text-opacity-70 tracking-wider mb-4 font-light">
                                Gallabox now available on Android and IOS
                            </p>
                            <div className="flex items-center justify-center lg:justify-start">
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://play.google.com/store/apps/details?id=com.mangoleap.gallabox&utm_source=Landing%20Page"
                                    className="track_playstore -ml-2"
                                >
                                    <img
                                        alt="Get it on Google Play"
                                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                        className="w-36"
                                        width="9rem"
                                    />
                                </a>
                                <a className="track_applestore" target="_blank" rel="noreferrer" href="https://apps.apple.com/in/app/gallabox/id1542957177">
                                    <img
                                        alt="Download on the App Store"
                                        src="https://assets.gallabox.com/gb-home/appstore-badge.svg"
                                        width="7.15rem"
                                        style={{ width: "7.15rem" }}
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="flex md:hidden">
                            <img
                                className="-top-4 mx-auto lg:mr-auto w-full max-w-xs h-64 object-none object-top"
                                alt="Gallabox mobile app"
                                src="https://assets.gallabox.com/gb-home/homepage-mobile.svg"
                            />
                        </div>
                    </div>
                </section>
            </section>
            {showModal && <Modal onClose={handleClose} modalHeader={modalHeader} ctaLabel="Get started" subjectSuffix={`${slug}-landing-page [Top CTA Get Started]`} />}
        </NewLayout>
    );
};

export default IntegrationTemplate;
